import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs';
import { ManifestInterface } from '@kaiser-software/chassis-core/src/app/core-bootstrap.module';

@Injectable()
export class ConfigService {

    protected config = {};

    /**
     * Load the service by injecting the ENVIRONMENT token
     *
     * @param environment
     */
    public constructor(@Inject('ENVIRONMENT') environment, @Inject(Http) protected http) {
        this.setObject(environment);
    }

    /**
     * Get the config value by the given key
     *
     * @param key
     * @returns {any}
     */
    public get(key: string) {
        if (this.exists(key)) {
            return this.config[key];
        }

        return false;
    }

    /**
     * Set config variable
     *
     * @param key
     * @param value
     */
    public set(key: string, value: any) {
        this.config[key] = value;
    }

    /**
     * Set config key values by a given object
     *
     * @param configObject
     */
    public setObject(configObject: Object) {
        for (const key in configObject) {
            this.config[key] = configObject[key];
        }
    }

    /**
     * Delete a config variable by the given key
     *
     * @param key
     */
    public delete(key: string) {
        if (this.exists(key))
            delete this.config[key];
    }

    /**
     * Check if key exists
     *
     * @param key
     * @returns {boolean}
     */
    public exists(key: string) {
        return this.config[key] !== undefined;
    }

    /**
     * Check the backend version
     * -> update caches if version changed
     */
    public checkVersion() {
        const subject                     = new Subject();
        const manifest: ManifestInterface = JSON.parse(localStorage.getItem('manifest'));

        const api_url = this.get('api_url');

        this.http.get(api_url + '/manifest.json').subscribe((response) => {

            const manifestFile: ManifestInterface = response.json();

            if (manifest === null || manifestFile.timestamp > manifest.timestamp) {

                console.warn('Update manifest file -> clear all caches', manifestFile);

                localStorage.setItem('manifest', JSON.stringify(manifestFile));

                localStorage.removeItem('entities-all-cache');
                localStorage.removeItem('entities-all-cache-expiry');
                localStorage.removeItem('settings-all-cache');
                localStorage.removeItem('settings-all-cache-expiry');
                localStorage.removeItem('translations-nl');
                localStorage.removeItem('translations-nl-last_checked_for_updates');
                localStorage.removeItem('translations-nl-last_modified');
            }

            subject.next(true);
        }, error => {
            console.error('Something went wrong while checking the backend version', error);
        });

        return subject;
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/config/config.service.ts